export default __webpack_public_path__ + "static/media/vigot-screenshot-06.75bddd73.png";